import codes from '@/codes';
import reg from '@/reg';
import PartnerDetail from '../../partner/partner.Detail.i18n';
import UserList from '../../user/user.List.i18n';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as _ from 'lodash';
import SecurityPolicy from '../../group/SecurityPolicy.i18n';
import InstallHistoryList from '@/views/History/install/install.List.i18n'
import InvoiceHistoryList from '@/views/Billing/invoice.group/invoice.group.List.i18n'
import QNAList from '@/views/Board/qna/qna.List.i18n'

import DatePicker from 'vue2-datepicker'
import VueMonthlyPicker from 'vue-monthly-picker'
import custom from '@/custom';
import moment from 'moment-timezone'

//restful api
import { group as manager, partner } from '@/service/api/manager'
import { group as billing, license } from '@/service/api/billing'

const default_model = () => (
  { service : codes.service_default, allow_mail : true, is_alive : true }
);

export default {
  components: {
    VueMonthlyPicker,
    QNAList,
    DatePicker,
    InvoiceHistoryList,
    InstallHistoryList,
    SecurityPolicy,
    UserList,
    cSwitch,
    vSelect,
    PartnerDetail
  },
  data : () => {
    return {
      ticket_invoice_month : '',
      custom,
      confirm_ticket_invoice : false,
      index : 0,
      partnerOpt : ["username", "nickname"],
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'username', sv: '', skt: 'username', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : Object.assign(default_model(), { info : { wc_count : 0, wsf_count : 0, wf_count : 0, wmds_count : 0 }, email_cc : [] }),
      lock : true,
      codes,

      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      partner_service : []
    }
  },
  methods: {
    //ip reset
    async send_ip_reset_mail() {
      let rs = await manager.resetGroup({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending IP ACL Reset Mail", "failed") : this.$toastr.s("IP ACL Reset Mail", "Sented");
    },
    // 매니저의 강제 인보이스 발급
    ticket_invoice() {
      if(moment(this.ticket_invoice_month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      } else if(!this.ticket_invoice_month) {
        return this.$toastr.w("plz, select date")
      }
      let body = {
        group_id : this.model.id,
        // month : this.ticket_invoice_month.format("YYYY-MM-DD")
        month : moment(this.ticket_invoice_month).format('YYYY-MM-DD')
      }

      return billing.ticketGroup(body)
        .then(rs => {
          if(rs.error) { return this.$toastr.w("failed ticket invoice") }
          this.$refs ? this.$refs._list_invoice.refresh() : ''
          this.$emit('refresh')
          rs.error ? this.$toastr.w("failed ticket invoice") : this.$toastr.i("created invoice")
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    load_partner_service() {
      try{
       let partner_service_info = {
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '=' }, { name : 'is_alive', value : true, op : '=' }] }
        }
        // 파트너와 함께 그룹 생성할 경우
        if(this.$route.params.tag == "partner") {
          console.log("load partner's service")
          partner_service_info.body.and.push({ name : 'partner_id', value : Number(this.$route.params.id), op : '=' })
        }

        // 그룹을 직접 생성할 경우
        if(this.$route.params.id == "add") {
          console.log("load partner's service")
          partner_service_info.body.and.push({ name : 'partner_id', value : 1, op : '=' })
        } else {
          // 파트너 서비스 로드
            partner_service_info.body.and.push({ name : 'partner_id', value : this.model.partner_id, op : '=' })
        }


        // if(this.$route.params.id && !this.$route.params.tag) {
        //   console.log("load partner's service")
        //   partner_service_info.body.and.push({ name : 'partner_id', value : this.model.partner_id, op : '=' })
        // }

        // console.log(partner_service_info)

        license.listLicense(partner_service_info).then(rs => {
        if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }

        rs.body.forEach(x => {
          if(!x.is_publish) {
            return console.log('not puglished', x.service_name)
          }
          if(this.model.service_id == x.id) {
            // 자기 서비스 찾아서 넣기
            this.model = Object.assign({}, this.model, { service : x })
            console.log('updated service', x.service_name)
          }
          this.partner_service.push({ service_name : x.service_name, id : x.id })
          console.log("service : ", this.partner_service)
        })

        this.model.service.service_name = this.partner_service[this.partner_service.length - 1].service_name
        this.model.service.value = this.partner_service[this.partner_service.length - 1].id

        // if(!this.model.service_name) { this.model.service_name = this.partner_service[this.partner_service.length - 1].name }
        
        }).catch(e => console.log("check : ", e))
        // }).catch(e => this.$toastr.e(e, e.status, e.statusText))
      } catch(e) { this.$toastr.e(e.data, e.status, e.statusText); }
    },
    edit:function() { 
      this.lock = false;

      //checkbox lock 풀기
      if(!this.lock){
        $('.checkbox-animate').removeClass('disabled')}
      },
    set_service:function(x) { if(!x) { return; } this.model.service_id = x.id },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true

      // checkbox lock 걸기 위해서 필요
      if(this.lock){
        $('.checkbox-animate').addClass('disabled')
      }

      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'group' }); this.$emit('refresh'); },
    remove: function() {
      //model.count = 사용자 수
      if(this.model.count) { this.$toastr.w('User exists', 'Warning'); return; }

      // this.model.is_del = true;
      manager.deleteGroup({ id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list();
          this.refresh();
        }).catch(e => (console.log("e : ", e), this.$toastr.e(e ? e.data || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    loadPartner() {
      // if(!this.so.sv) { return console.log("open modal") }
      let so = {
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(this.so.sv) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }) }

      return partner.listPartner(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(this.model.service == ''|| this.model.service == undefined) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        // set region
        if(!this.region.country) { return this.$toastr.e('Country Required.'); }
        if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
        if(!this.region.language) { return this.$toastr.e('Language Required.'); }

        if(this.$route.params.tag == "partner" && Number(this.$route.params.id) > 0) { this.model.partner_id = Number(this.$route.params.id) }

        let model = this.model;

        if(this.partner) { model.partner_id = this.partner.parent_id ? this.partner.parent_id : this.partner.id }

        if(this.model.syslog_list) {
          model.syslog = _.uniq(_.compact(this.model.syslog_list.replace(/,/gm, '').split("\n")));
          // b-form-textarea has bug, can not bind model so rirect update
          this.model.syslog_list = _.join(model.syslog, '\n')
          this.$refs.syslog_list.localValue = _.join(model.syslog, '\n')
        }

        if(this.model.email_cc_list) {
          model.email_cc = _.uniq(_.compact(this.model.email_cc_list.replace(/,/gm, '').split("\n")));
          // b-form-textarea has bug, can not bind model so rirect update
          this.model.email_cc_list = _.join(model.email_cc, '\n')
          this.$refs.email_cc_list.localValue = _.join(model.email_cc, '\n')
        }

        let region = {};
        region.country = this.region.country.value
        region.language = this.region.language.value
        region.timezone = this.region.timezone.value

        let service = this.model.service.service_name ? this.model.service.service_name : this.model.service
        // let service_id = this.model.service.service_name ? this.model.service.id : 0

        let check_id = '';
        check_id = this.model.id ? `${await manager.updateGroup(Object.assign({}, this.model, model, region, { service : service }))}` : `${ await manager.insertGroup(Object.assign({}, this.model, model, region, { service : service }))}`;

        let rs = check_id;

        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        
        this.lock = true;
        // this.refresh(rs.body.id)
      } catch(e) { console.log(e); this.$toastr.e(e ? e.data || e.data.title : e.statusText); this.list()}

      this.lock = true;
      this.list();
    },
    get: async function({ id, tag } = this.$route.params) {
      if(tag == 'partner') {
        try {
          this.passPartner = true;

          let rs = await partner.detailPartner({ id : id })

          this.model.partner = Object.assign({}, this.model.partner, rs.body)
          this.model.partner_id = this.model.partner.id;
          this.passPartner = false;

        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
      }
      // console.log('group.detail.vue', 'load item', 'id', id, 'tag', tag);
      if(id === 'add' || tag === 'partner') { this.model.is_verified = true; this.add = (tag != 'partner'); this.lock = false; return this.load_partner_service(); }
      else {
        manager.detailGroup({ id : id }).then(rs => this.model = Object.assign({ group: {} }, this.model, rs.body))
        .then(() => {

          this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")
          this.model = Object.assign({}, this.model, { syslog_list : this.model.syslog && this.model.syslog.join("\n"), email_cc_list : this.model.email_cc && this.model.email_cc.join("\n") } )

          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

          if(!this.model.service_name) { this.model.service_name = this.model.service }

          this.load_partner_service()
          this.load_using_status()

          // checkbox lock 걸기 위해서 필요
          if(this.lock){
            $('.checkbox-animate').addClass('disabled')
          }

        }).catch(e => {console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()});
      }
    },
    refresh(id) { id ? this.$router.push({ name: 'group', params : { id : id ? id : this.$route.params.id } }) :  this.$emit('refresh'); },
    load_using_status() {
          manager.infoGroup({ id : this.model.id  }).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }
          this.model.info = Object.assign({}, this.model.info, rs.body)
        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
    },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); this.$root.$on('selected', this.setPartner); this.$on('refresh', this.refresh()) } },
  created: function() { console.log('group.detail.vue', 'created'); },
  destroyed: function() { console.log('group.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('group.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}